import React, { Component } from 'react';

/** Core */
import InputDate from '../../../core/InputDate';
import Label from '../../../core/Label';
import Buttons from '../../../core/Buttons';
import WrapperControl from '../../../core/WrapperControl';
import DropdownInput from '../../../core/DropdownInput';

/** Utils */
import { formatDateHyphen } from '../../../../utils/formatDate';

/** Styles */
import { StyledSearchFormControl } from './style';

class SearchFormControl extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dateFrom: null,
      dateTo: null,
      userSelected: null
    };
  }

  handleData = (value, type) => {
    if (type === 'from') {
      this.setState({ dateFrom: formatDateHyphen(value) });
    }
    if (type === 'to') {
      this.setState({ dateTo: formatDateHyphen(value) });
    }
    if (type === 'userSelected') {
      if (value != null) {
        this.setState({ userSelected: value.value });
      } else {
        const allUserValues = this.props.listUsers.map(user => user.value);
        this.setState({ userSelected: allUserValues });
      }
    }
  };

  handleSend = () => {
    const { userSelected, dateFrom, dateTo } = this.state;
    const { onSubmit, listUsers } = this.props;
    onSubmit(
      userSelected != null ? userSelected : listUsers.map(user => user.value),
      dateFrom,
      dateTo
    );
  };

  handleSendExcel = () => {
    const { userSelected, dateFrom, dateTo } = this.state;
    const { onSubmitExcel, listUsers } = this.props;
    onSubmitExcel(
      userSelected != null ? userSelected : listUsers.map(user => user.value),
      dateFrom,
      dateTo
    );
  };

  render() {
    return (
      <StyledSearchFormControl>
        <WrapperControl>
          <Label label="Fecha desde" className="mb-5" />
          <InputDate
            className="mr-15"
            onChange={e => this.handleData(e, 'from')}
          />
        </WrapperControl>
        <WrapperControl>
          <Label label="Fecha hasta" className="mb-5" />
          <InputDate
            className="mr-15"
            onChange={e => this.handleData(e, 'to')}
          />
        </WrapperControl>
        <WrapperControl>
          <Label label="Usuario" className="mb-5" />
          <DropdownInput
            className="form-dropdown"
            list={this.props.listUsers}
            label="Selecciona usuario"
            onSelect={e => this.handleData(e, 'userSelected')}
            allowUnselected
          />
        </WrapperControl>
        <WrapperControl>
          <div className="wrapper-btn-send">
            <Buttons className="btn-send" dark onClick={this.handleSend}>
              Buscar
            </Buttons>
          </div>
        </WrapperControl>
        <WrapperControl>
          <div className="wrapper-btn-send">
            <Buttons className="btn-send" green onClick={this.handleSendExcel}>
              Descargar excel
            </Buttons>
          </div>
        </WrapperControl>
      </StyledSearchFormControl>
    );
  }
}

export default SearchFormControl;
